module.exports = __webpack_public_path__ + "img/desk2.8db6b5a1.png";